import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SideNavBar, ProtectedRoute } from "./components";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import "./App.css";

import {
  AdminDashboard,
  ClassAttendance,
  Code,
  Dashboard,
  Exams,
  Help,
  LogIn,
  MySchedule,
  NotFound,
  StandardClass,
  Workshop,
} from "./pages";

const MainLayout = () => {
  return (
    <div className="contains-all">
      <SideNavBar />
    </div>
  );
};

export const App = () => {
  return (
    <>
      <div>
        <ReactNotifications />
      </div>
      <BrowserRouter>
        <Routes>
          <Route path="" element={<LogIn />} />
          <Route path="" element={<MainLayout />}>
            <Route
              path="dashboard"
              element={
                <ProtectedRoute
                  key="dashboard-route"
                  allowedAuthorities={[
                    "ROLE_ADMIN",
                    "ROLE_STUDENT",
                    "ROLE_TEACHER",
                    "ROLE_FINANCIAL",
                    "ROLE_ASSISTANCE",
                  ]}
                >
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="code"
              element={
                <ProtectedRoute
                  key="code-route"
                  allowedAuthorities={["ROLE_STUDENT"]}
                >
                  <Code />
                </ProtectedRoute>
              }
            />
            <Route
              path="admindashboard"
              element={
                <ProtectedRoute
                  key="admin-dashboard-route"
                  allowedAuthorities={[
                    "ROLE_ADMIN",
                    "ROLE_FINANCIAL",
                    "ROLE_ASSISTANCE",
                  ]}
                >
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="class_attendance"
              element={
                <ProtectedRoute
                  key="class-attendance-route"
                  allowedAuthorities={["ROLE_ADMIN", "ROLE_TEACHER"]}
                >
                  <ClassAttendance />
                </ProtectedRoute>
              }
            />
            <Route
              path="standard_class"
              element={
                <ProtectedRoute
                  key="standard-class-route"
                  allowedAuthorities={["ROLE_STUDENT"]}
                >
                  <StandardClass />
                </ProtectedRoute>
              }
            />
            <Route
              path="workshop"
              element={
                <ProtectedRoute
                  key="workshop-route"
                  allowedAuthorities={["ROLE_STUDENT"]}
                >
                  <Workshop />
                </ProtectedRoute>
              }
            />
            <Route
              path="exams"
              element={
                <ProtectedRoute
                  key="exams-route"
                  allowedAuthorities={["ROLE_STUDENT"]}
                >
                  <Exams />
                </ProtectedRoute>
              }
            />
            <Route path="my_schedule" element={<MySchedule />} />
            <Route path="help" element={<Help />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
